export const EDIT_CONTRACT_DETAILS_MODAL_NAME =
  'EDIT_CONTRACT_DETAILS_MODAL_NAME';
